const stats = [
  { value: "1,280+", label: "收录作品", icon: "ri-film-line" },
  { value: "3,600+", label: "动漫资讯", icon: "ri-newspaper-line" },
  { value: "480+", label: "角色解析", icon: "ri-user-star-line" },
  { value: "每日", label: "内容更新", icon: "ri-time-line" },
];

export default function StatsStrip() {
  return (
    <section aria-label="站点内容数据" className="border-y border-background-200 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-5 md:py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-3">
              <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 shrink-0">
                <i className={`${stat.icon} text-base`}></i>
              </span>
              <div className="min-w-0">
                <p className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-none">{stat.value}</p>
                <p className="text-[11px] md:text-xs text-foreground-500 mt-1.5">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}